import React, { useEffect } from 'react';

interface IntegrityAdvocateProps {
	appId: string;
	participantIdentifier: string;
	courseId: string;
	participantFirstName: string;
	participantLastName: string;
	participantEmail: string;
	activityId: string;
}

function IntegrityAdvocate({
	appId,
	participantIdentifier,
	courseId,
	participantFirstName,
	participantLastName,
	participantEmail,
	activityId,
}: IntegrityAdvocateProps) {
	useEffect(() => {
		const scriptId = `integrity-advocate-script-${courseId}`;
		if (!document.getElementById(scriptId)) {
			const script = document.createElement('script');
			script.id = scriptId;
			script.src = `https://ca.integrityadvocateserver.com/participants/integrity?appid=${appId}&participantidentifier=${encodeURIComponent(
				participantIdentifier,
			)}&courseid=${encodeURIComponent(courseId)}&participantfirstname=${encodeURIComponent(
				participantFirstName,
			)}&participantlastname=${encodeURIComponent(participantLastName)}&participantemail=${encodeURIComponent(
				participantEmail,
			)}&activityid=${encodeURIComponent(activityId)}`;
			script.async = true;

			document.body.appendChild(script);
		}

		// return () => {
		// 	const existingScript = document.getElementById(scriptId);
		// 	if (existingScript) {
		// 		document.body.removeChild(existingScript);
		// 	}
		// };
	}, [
		appId,
		participantIdentifier,
		courseId,
		participantFirstName,
		participantLastName,
		participantEmail,
		activityId,
	]);

	return <div id="integrity-advocate-container" />;
}

export default IntegrityAdvocate;
